import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import './task.css';

import axios from 'axios';
import {axiosEH} from './common/functions'
//import jwtUser from '../jwtUser';

export default function Task() {
  // 1. 1st-level vars
  const [statusMsg, setStatusMsg] = useState('');
  let [tbList, setTbList] = useState([{}]); // no added header

  const user = JSON.parse(sessionStorage.getItem('user'));
  const isTeacher = (user && user.isTeacher) ? true : false;
  let tbHeaders, tbRows;
  const tbodyID="taskTable";

  // send task to record
  const history = useHistory(); //! not work if put inside of below func

  try {
    //const user = jwtUser(); // get user token
  
    // ---- f()
    function removeTask(student, buID, TPID, tType) {
      let url = process.env.REACT_APP_BASEURL + '/usertasks/removetask';
      axios.post(url, {
        username: user.username,
        student: student,
        bookUnitID: buID,
        TPID: TPID,
        Type: tType,
      }, { headers: { 'x-access-token': user['accessToken'] } })
        .then(res => {
          if (res.status == 200) {
            setStatusMsg(res.data);
          }
          window.location.reload();
        })
        .catch(err => { 
          setStatusMsg(axiosEH(err)); 
        })
    }

    function getUserTasks() {
      let tokenExpAt, tokenExpInMS, tokenExpInMM;
      let tokenTimeoutID = sessionStorage.getItem('tokenTimeoutID');
      const url = process.env.REACT_APP_BASEURL + '/usertasks';

      axios.get(url, { headers: { 'x-access-token': user['accessToken'], teachername: user.teachername  } })
        .then(res => {
          //console.log(JSON.stringify(res.data));
          if ( !Array.isArray(res.data) ) {
            setStatusMsg(res.data.info);
            setTbList([]);
          } else {
            tokenExpAt = res.data.pop().tokenExpAt;
            tokenExpInMS = parseInt((tokenExpAt * 1000 - Date.now()));
            tokenExpInMM = parseInt(tokenExpInMS / 60000);
            setStatusMsg(`user auth will expire in ${tokenExpInMM} minutes`);

            clearTimeout(tokenTimeoutID);
            tokenTimeoutID = setTimeout(() => {
              sessionStorage.clear();
              window.location.href = "/login";
            }, tokenExpInMS);
            sessionStorage.setItem('tokenTimeoutID', tokenTimeoutID);

            // 2) ISODate to local
            for (const [i, el] of res.data.entries()) {
              res.data[i].dueBy = getLTime(el.dueBy);
            }
            // 3)
            setStatusMsg('');
            setTbList([...res.data]);
          }
        })
        .catch(err => { 
          setStatusMsg(axiosEH(err)); 
        })
    }

    function tableEvent() {
      const tbTable = document.getElementById(tbodyID);
      let student, bookUnitID, TPID, Type;

      function getRowCellValues(row) {
        student = row.cells[1].innerHTML;
        bookUnitID = row.cells[2].innerHTML;
        TPID = row.cells[3].innerHTML;
        Type = row.cells[4].innerHTML;
        return ([student, bookUnitID, TPID, Type])
      }

      if (tbTable != null) { // not 1st rend
        console.log('taskTable exist')
  
        tbTable.addEventListener('click', function (event) {	// 1-click, 'dblclick
          event.stopImmediatePropagation();
          const cell = event.target.closest('td');
          if (!cell) {return;} // Quit, not clicked on a cell: 0% ? 
          const cellValue = cell.innerHTML;  // string, do not use index
          const row = cell.parentElement;
          if (cellValue == 'PA' || cellValue == 'SB' || cellValue == 'FS') {
            [student, bookUnitID, TPID, Type] = getRowCellValues(row);
            console.log('do task: student, bookUnitID, TPID, Type:', student, bookUnitID, TPID, Type);
            // record params: [bookUnitID, TPID, teacher]
            if (cellValue == 'PA') {
              history.push("/record", { taskId: [bookUnitID, TPID, Type, user.teachername] });
            } else if (cellValue == 'SB') {
              history.push("/spellingbee", {taskId: [bookUnitID, TPID, Type, user.teachername] });
            } else {
              history.push("/flashcardmaster", {taskId: [bookUnitID, TPID, Type, user.teachername] });
            }
  
          } else if (cellValue.includes('X') ) {  // -task
            [student, bookUnitID, TPID, Type] = getRowCellValues(row);
            console.log('do task: student, bookUnitID, TPID, Type:', student, bookUnitID, TPID, cellValue);
            removeTask(student, bookUnitID, TPID, Type);
          } 
        });
      } else {
        console.log('error: taskTable not exist')
      }
    }

    const getLTime = isoDT => { // nw
      const isoDateTime = new Date(isoDT);
      const localDT = isoDateTime.toLocaleDateString() + " " + isoDateTime.toLocaleTimeString();
      return localDT.slice(0, 10);  //10 w/o hh:mm, 16 hh:mm
    };

    if (tbList.length >0) {
      tbHeaders = Object.keys(tbList[0]);
      tbRows = tbList.map(item => Object.values(item));
    }

    React.useEffect(() => {
      getUserTasks();
      tableEvent();
    }, []);   // []: render once only

  }
  catch (err) {
    setStatusMsg(err.message);
  }

  return (
    <section >
      {(tbList.length >0) && <div className="taskList mx-5">
        <p style={{color: 'grey'}} ><b>Click</b> the Type column content FS or SB to do the task</p>
        {isTeacher && <p style={{color: 'grey'}}><b>Click</b> the X cell to remove the task</p> }
        <table id="task-table">
          <thead>
            <tr>
              {tbHeaders.map(header => <th key={header}>{header}</th>)}
            </tr>
          </thead>
          <tbody id={tbodyID}>
            {tbRows.map((row, index) => (
              <tr key={index}>
                {row.map((cell, index) => <td key={index}>{cell}</td>)}
                {isTeacher && <td><span style={{ background: 'yellow' }} >X</span></td> }
              </tr>
            ))}
          </tbody>
        </table>
        <br></br>
      </div> }
      <label className="label has-text-success">{statusMsg}</label>
    </section>
  );
}